export const unwrapProductList = (data) => {
  if (Array.isArray(data)) return data;
  if (data && typeof data === "object") {
    if (Array.isArray(data.items)) return data.items;
    if (Array.isArray(data.data)) return data.data;
  }
  return [];
};

/** Public catalog items use `isActive` in the dashboard; tolerate `isPublished` if present. */
export const isPublishedProduct = (item) => {
  if (!item || typeof item !== "object") return false;
  if (item.isActive === false) return false;
  if (item.isPublished === false) return false;
  return true;
};

export const filterPublishedProducts = (list) =>
  unwrapProductList(list).filter(isPublishedProduct);
